import * as React from "react";
import Wishlist from "./Wishlist";
import WishlistContext from "../services/WishlistContext";
import WishlistService from "../services/WishlistService";
import useNotification from "./notification/useNotification";
import Placeholder from "./Placeholder";
import EmptyWishlist from "./EmptyWishlist";
import WishlistOverwritePopup from "./WishlistOverwritePopup";
import { IWishlist } from "../models/IWishlist.model";
import NotificationType from "./notification/NotificationType";
import Helpers from "../../../gulp/scripts/typescript/modules/helpers";


function App() {
	const [isLoading, setIsLoading] = React.useState(false);
	const [wishlist, setWishlist] = React.useState<IWishlist>();
	const { addNotification } = useNotification();
	const wishlistService = new WishlistService();
	const [wishlistPrefillUrl, setWishlistPrefillUrl] = React.useState("");
	const [showWishlistOverwritePopup, setShowWishlistOverwritePopup] = React.useState(false);

	React.useEffect(() => {
		getWishlist();
	}, []);

	function getWishlist() {
		setIsLoading(true);
		if (location.search) {
			checkWishlistConflict(location.search);
		}
		wishlistService
			.getWishlist()
			.then((data) => {
				setIsLoading(false);
				setWishlist(data);
				wishlistService.trackViewWishlist(data);
			})
			.catch(() => {
				setIsLoading(false);
				addNotification({
					headline: 'An error has occurred trying to retrieve your wishlist. Please try again.',
					type: NotificationType.error
				});
			});
	}

	function checkWishlistConflict(queryString: string) {
		const params = new URLSearchParams(queryString);
		if (params.has("wishlistConflict")) {
			params.delete("wishlistConflict");
			setWishlistPrefillUrl(`/wf?${params.toString()}`);
			setShowWishlistOverwritePopup(true);
		}
	}

	React.useEffect(() => {
		if (document && wishlist) {
			const updateWishlistSummaryCount = Helpers.createCustomEventForDispatch('updateWishlistSummaryCount', {
				count: wishlist.TotalItemQuantity
			});
			document.dispatchEvent(updateWishlistSummaryCount);
		}
	}, [wishlist]);

	if (!wishlist) {
		return <Placeholder />;
	}

	return (
		<div className={isLoading ? "is-loading" : ""}>
			<WishlistContext.Provider
				value={{
					wishlist,
					setWishlist,
				}}
			>
				{showWishlistOverwritePopup ?
					<WishlistOverwritePopup wishlistPrefillUrl={wishlistPrefillUrl} />
				: null}
				{wishlist?.TotalItemQuantity === 0 ? (
					<EmptyWishlist />
				) : (
					<React.Fragment>
						<Wishlist />
					</React.Fragment>
				)}
			</WishlistContext.Provider>
		</div>
	);
}

export default App;
